import { render, staticRenderFns } from "./smsAnalysis.vue?vue&type=template&id=affd0a8e&scoped=true"
import script from "./smsAnalysis.vue?vue&type=script&lang=js"
export * from "./smsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./smsAnalysis.vue?vue&type=style&index=0&id=affd0a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affd0a8e",
  null
  
)

export default component.exports